import * as React from "react";
import { DatePicker } from "components/common";
import { toUTCFromTz, toDateObject } from "util/DateTime";
import useUserDateTime from "hooks/useUserDateTime";
const AbsoluteDatePicker = ({ dateTime, onChange = () => {
}, startDate = void 0 }) => {
  const { userTimezone, formatTime } = useUserDateTime();
  const initialDateTime = toUTCFromTz(dateTime, userTimezone);
  const initialDate = formatTime(initialDateTime, "date");
  const _onDatePicked = (selectedDate) => {
    if (!!startDate && toDateObject(selectedDate).isBefore(toDateObject(startDate), "day")) {
      return false;
    }
    const selectedDateObject = toDateObject(selectedDate);
    const validInitialDateTime = initialDateTime.isValid() ? initialDateTime : toUTCFromTz(void 0, userTimezone);
    const newDate = validInitialDateTime.set({
      year: selectedDateObject.year(),
      month: selectedDateObject.month(),
      date: selectedDateObject.date()
    });
    return onChange(formatTime(newDate, "default"));
  };
  return /* @__PURE__ */ React.createElement(DatePicker, { date: initialDate, onChange: _onDatePicked, fromDate: startDate });
};
export default AbsoluteDatePicker;
